import Input from "components/Elements/Input";
const TextAreaField = ({ name, param, value, onChange = () => {} }) => {
  return (
    <>
      <Input type="textarea" name={name} value={value} onChange={onChange} />
    </>
  );
};

export default TextAreaField;
